import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyFontPrefs, applyTheme, loadFontPrefs, loadTheme } from './theme';
import './styles.css';

const host = document.getElementById('root');
if (!host) throw new Error('#root nao encontrado no index.html');

// O script inline do index.html ja repintou o tema antes do primeiro paint.
// Este passo existe para o caso dele nao ter rodado (primeiro boot, sem nada
// salvo) e para curar um `cssVars` gravado por uma versao anterior do app:
// aqui o tema passa pelo parseTheme atual e volta normalizado.
applyTheme(loadTheme());
applyFontPrefs(loadFontPrefs());

createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
